import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsBikeNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 13.01a3.5 3.5 0 003.46-3h1.08a3.5 3.5 0 102.42-3.84L9.83 4.01H11a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5H8.17l1.05 2h-3.1l-.532-1h.982l-.53-1H3.05l.53 1h.879l.747 1.407-.376.693a3.5 3.5 0 10-.83 6.9zm6.52-5.51l1.32 2.51h1.13l-1.54-2.93a2.12 2.12 0 01.57-.07 2.5 2.5 0 11-2.233 1.372c.178-.35.436-.652.753-.882zm-.78-1.49l.31.6a3.452 3.452 0 00-1.51 2.4h-.291l-1.6-3H9.74zm-3.972.463L7.117 9.01H4.4l1.368-2.537zM4 7.01c.11 0 .221.01.33.03L3.22 9.1l.47.91h2.76a2.5 2.5 0 11-2.45-3z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsBikeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsBikeNormalXsmall;
